import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tebuto/webapp/app/landing/(main)/kontakt/Contact.tsx");
